















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { default as VSelect } from 'vue-select';

// @ts-ignore
@Component({
  components: {
    VSelect,
  },
})
export default class PartSidebar extends Vue {
  @Getter('workspace/all') workspaces!: Workspace[];

  @Getter('workspace/selected') workspace!: Workspace;

  @Prop({ default: 350 }) width!: number;

  @Prop({ default: 100 }) headerHeight!: number;

  activeHeader: { [key: string]: boolean } = {
    products: false,
    users: false,
    settings: false,
  };

  mounted() {
    const navGroup: Array<'products' | 'users' | 'settings'> = this.$route.meta.navGroup;
    if (navGroup && navGroup.includes('products')) {
      this.activeHeader.products = true;
    }
    if (navGroup && navGroup.includes('users')) {
      this.activeHeader.users = true;
    }
    if (navGroup && navGroup.includes('settings')) {
      this.activeHeader.settings = true;
    }
  }

  get workspaceOptions() {
    return this.workspaces.map((ws) => ({ value: ws.id, label: ws.name }));
  }

  protected changeWorkspace({ value }: { value: number }) {
    const workspace = this.workspaces.find((ws) => ws.id === value);
    this.$store.dispatch('workspace/select', { workspace });
  }

  get hasSidebarPart() {
    return !!this.$slots.sidebar;
  }

  get visibleTabs() {
    return this.workspace.config?.visible_tabs ?? [];
  }
}
